import { useState, useEffect } from "react";
import { auth, db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";

export const useSubscriptionStatus = () => {
  const [isActive, setIsActive] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    const checkSubscription = async () => {
      try {
        const user = auth.currentUser;
        if (!user) {
          setIsActive(false);
          setLoading(false);
          return;
        }

        const userDocRef = doc(db, "users", user.uid);
        const userDoc = await getDoc(userDocRef);

        if (userDoc.exists()) {
          const userData = userDoc.data();
          setUserData(userData);
          // subscription 정보가 있고 status가 'active'인 경우
          if (
            userData.subscription &&
            userData.subscription.status === "active"
          ) {
            // 종료일 확인 로직 추가
            if (userData.subscription.endDate) {
              const endDate = new Date(userData.subscription.endDate);
              const now = new Date();

              if (endDate > now) {
                console.log("구독 정보:", userData.subscription);
                setIsActive(true);
              } else {
                console.log(
                  "구독 기간이 만료되었습니다:",
                  userData.subscription
                );
                setIsActive(false);
              }
            } else {
              console.log("구독 정보:", userData.subscription);
              setIsActive(true);
            }
          } else {
            setIsActive(false);
          }
        } else {
          setIsActive(false);
        }
      } catch (err) {
        console.error("구독 상태 확인 중 오류:", err);
        setError(err);
        setIsActive(false);
      } finally {
        setLoading(false);
      }
    };

    // auth 상태 변경 감지
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        checkSubscription();
      } else {
        setIsActive(false);
        setLoading(false);
      }
    });

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    if (userData && userData.subscription) {
      console.log("구독 정보:", userData.subscription);

      const { status, startDate, endDate } = userData.subscription;
      const now = new Date();
      const endDateObj = endDate ? new Date(endDate.seconds * 1000) : null;

      console.log("현재 시간:", now);
      console.log("종료 시간:", endDateObj);

      // 구독 상태 확인 로직
      const isActive = status === "active" && (!endDateObj || now < endDateObj);
      const isExpired = endDateObj && now > endDateObj;

      console.log("구독 상태 계산:", {
        status,
        현재시간: now.toISOString(),
        종료시간: endDateObj?.toISOString(),
        isActive,
        isExpired,
      });

      setIsActive(isActive);
    }
  }, [userData]);

  return { isActive, loading, error };
};
